import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { FinanceComparison } from "../../types/FinanceComparison";

export const getQuoteFinanceComparison = (quoteId: string) => {
  const { fetchWithAuth } = useApi();

  return useQuery({
    queryKey: ["quote-finance-comparison", quoteId],
    queryFn: (): Promise<FinanceComparison> => {
      return fetchWithAuth<FinanceComparison>(
        "getQuoteFinanceComparison",
        quoteId
      );
    },
  });
};
